import QueryBuilder from "../QueryBuilder"

export default class ThreeColumnImageRepository {
    constructor(protected contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "text_highlight",
                "subheaderText",
                "threeColumnSection",
            ])
            .process()

        return results.getResultInfo()
    }
}
